import { render } from "./designations-list-modal.vue?vue&type=template&id=0de33d24"
import script from "./designations-list-modal.vue?vue&type=script&lang=js"
export * from "./designations-list-modal.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__